export default "/react/note-125d2b6d.png";